import { render, staticRenderFns } from "./QuestionBackgroundModal.vue?vue&type=template&id=230d69f7&scoped=true&"
import script from "./QuestionBackgroundModal.vue?vue&type=script&lang=js&"
export * from "./QuestionBackgroundModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBackgroundModal.vue?vue&type=style&index=0&id=230d69f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d69f7",
  null
  
)

export default component.exports